(function () {
    window.gbg = window.gbg || {};
}());

(function () {
    'use strict';
    gbg.Accordions = (function () {

        // Function to get query parameters
        let getQueryParams = function () {
            let params = {};
            let queryString = window.location.search.substring(1);
            let queries = queryString.split("&");
            for (let i = 0; i < queries.length; i++) {
                let pair = queries[i].split("=");
                params[pair[0]] = decodeURIComponent(pair[1]);
            }
            return params;
        };

        let displayAccordions = function () {
            let acc = document.getElementsByClassName("accordion-button");
            let queryParams = getQueryParams();
            let keepOpen = queryParams.export !== undefined;

            for (let i = 0; i < acc.length; i++) {
                let accParent = acc[i].parentElement;

                if (keepOpen) {
                    // Keep all accordions open
                    acc[i].classList.add("active");
                    acc[i].classList.remove("inactive");
                    accParent.nextElementSibling.style.maxHeight = accParent.nextElementSibling.scrollHeight + "px";
                    accParent.nextElementSibling.classList.add("active");
                    accParent.nextElementSibling.classList.remove("inactive");
                } else {
                    // Set inactive class on button
                    acc[i].classList.add("inactive");

                    // Set the body height to 0 and add inactive class
                    accParent.nextElementSibling.style.maxHeight = 0 + "px";
                    if (accParent.nextElementSibling.classList.contains("accordion-body")) {
                        accParent.nextElementSibling.classList.add("inactive");
                    }
                }

                // On button click
                acc[i].addEventListener("click", function () {
                    let panel = this.parentElement.nextElementSibling;
                    if (this.parentElement.nextElementSibling.classList.contains("accordion-body") && this.parentElement.nextElementSibling.classList.contains("inactive")) {

                        // Collapse other active accordions
                        for (let j = 0; j < acc.length; j++) {
                            let ParentNextSib = acc[j].parentElement.nextElementSibling;

                            if (ParentNextSib.classList.contains("active")) {
                                ParentNextSib.style.maxHeight = 0 + "px";
                                ParentNextSib.classList.remove("active");
                                ParentNextSib.classList.add("inactive");
                                acc[j].classList.remove("active");
                                acc[j].classList.add("inactive");
                            }
                        }

                        // Set the height
                        if (panel.style.maxHeight === "0px" && panel.classList.contains("inactive")) {
                            panel.style.maxHeight = panel.scrollHeight + "px";
                            this.classList.add("active");
                            this.classList.remove("inactive");
                            panel.classList.add("active");
                            panel.classList.remove("inactive");
                        } else {
                            panel.style.maxHeight = 0 + "px";
                            panel.classList.remove("active");
                            panel.classList.add("inactive");
                        }
                    } else if (this.parentElement.nextElementSibling.classList.contains("accordion-body") && this.parentElement.nextElementSibling.classList.contains("active")) {
                        panel.style.maxHeight = 0 + "px";
                        panel.classList.remove("active");
                        panel.classList.add("inactive");
                        this.classList.add("inactive");
                        this.classList.remove("active");
                    }
                });
            }
        };

        let resizeAccordions = function () {
            let acc = document.getElementsByClassName("accordion-button");
            for (let i = 0; i < acc.length; i++) {
                if (acc[i].parentElement.nextElementSibling.classList.contains("active")) {
                    let panel = acc[i].parentElement.nextElementSibling;
                    if (panel.style.maxHeight) {
                        panel.style.maxHeight = null;
                    } else {
                        panel.style.maxHeight = panel.scrollHeight + "px";
                    }
                }
            }
        };

        // On window resize
        let windowResizeAccordions = function () {
            resizeAccordions();
        };

        return {
            displayAccordions: displayAccordions,
            windowResizeAccordions: windowResizeAccordions
        };
    }());

}());

window.addEventListener("resize", gbg.Accordions.windowResizeAccordions);

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", gbg.Accordions.displayAccordions);
} else {
    gbg.Accordions.displayAccordions();
}
